/* Cânon Nissi — WhatsApp Modal (carrinho misto) + Fluxo ENCOMENDAR pós-refresh (v6)
   Objetivo: 1 único refresh; adicionar item somente DEPOIS do refresh; zero duplicidade.
*/
(function(){
  if(window.__CN_ENCO_V6_BOOTED){ return; }
  window.__CN_ENCO_V6_BOOTED = true;

  var PDP_ONLY = /\/products\//.test(location.pathname);
  if(!PDP_ONLY) return;

  var INTENT_KEY = "cn_encomendar_intent_v6"; // {id, qty, ts, step}
  var INTENT_TTL = 120000; // 2 min

  // ========== utils ==========
  function q(s,c){ return (c||document).querySelector(s); }
  function qa(s,c){ return Array.prototype.slice.call((c||document).querySelectorAll(s)); }
  function now(){ return Date.now(); }
  function saveIntent(o){ try{ sessionStorage.setItem(INTENT_KEY, JSON.stringify(o)); }catch(e){} }
  function readIntent(){ try{ var v=sessionStorage.getItem(INTENT_KEY); return v?JSON.parse(v):null; }catch(e){ return null; } }
  function clearIntent(){ try{ sessionStorage.removeItem(INTENT_KEY); }catch(e){} }
  function fetchJSON(u){ return fetch(u,{credentials:'same-origin'}).then(function(r){ return r.json(); }); }
  function getCartJSON(){ return fetchJSON('/cart.js'); }

  // Bloqueio temporário de /cart/add.js enquanto modal estiver aberto
  window.__CN_BLOCK_CART_ADD = false;
  if(!window.__cn_block_patch){
    window.__cn_block_patch = true;
    var _fetch = window.fetch;
    window.fetch = function(resource, init){
      try{
        var url = (typeof resource === 'string') ? resource : (resource && resource.url) || '';
        if(window.__CN_BLOCK_CART_ADD && /\/cart\/add(\.js)?/i.test(url)){
          return Promise.resolve(new Response('{"status":"blocked"}', {status:200, headers:{'Content-Type':'application/json'}}));
        }
      }catch(e){}
      var ret = _fetch.apply(this, arguments);
      try{
        var url = (typeof resource === 'string') ? resource : (resource && resource.url) || '';
        if(/\/cart\/add(\.js)?/i.test(url)){
          ret = ret.then(function(resp){
            // If we set the force flag before add, suppress drawer immediately after success
            if(window.__CN_FORCE_WHATS_AFTER_ADD){
              setTimeout(function(){ try{ suppressCartDrawer(); }catch(e){} }, 30);
            }

            setTimeout(function(){
              try{
                var it = JSON.parse(sessionStorage.getItem('cn_add_disponivel_intent_v1')||'null');
                if(it && Date.now() - (it.ts||0) < 120000){
                  // After add finishes, check if cart is mixed; if so, open WhatsApp
                  getCartJSON().then(deriveCartTags).then(function(res){
                    if(res.isMixed || window.__CN_FORCE_WHATS_AFTER_ADD){ suppressCartDrawer(); openWhats(res.items); }
                  }).finally(function(){ try{ sessionStorage.removeItem('cn_add_disponivel_intent_v1'); }catch(e){} });
                }
              }catch(e){}
            }, 150);
            return resp;
          });
        }
      }catch(e){}
      return ret; };
    var X = window.XMLHttpRequest;
    function P(){ var x=new X(), o=x.open, s=x.send, tgt=''; x.open=function(m,u){ tgt=u||''; return o.apply(x,arguments); };
      x.send=function(b){ try{ if(window.__CN_BLOCK_CART_ADD && /\/cart\/add(\.js)?/i.test(tgt)){ setTimeout(function(){ try{x.status=200;}catch(e){}; try{x.onreadystatechange&&x.onreadystatechange();}catch(e){}; try{x.onload&&x.onload();}catch(e){}; },0); return; } }catch(e){}; return s.apply(x,arguments); };
      return x; }
    window.XMLHttpRequest = P;
  }
  function getVariantQty(){
    var form = document.querySelector('form[action*="/cart/add"]') || document.querySelector('form');
    var idEl = (form && (form.querySelector('input[name="id"]') || form.querySelector('select[name="id"]'))) || document.querySelector('input[name="id"]');
    var qtyEl= (form && form.querySelector('[name="quantity"]')) || document.querySelector('[name="quantity"]');
    var id  = idEl ? (idEl.value || idEl.getAttribute('value')) : null;
    var qty = qtyEl ? parseInt(qtyEl.value || qtyEl.getAttribute('value') || '1',10) : 1;
    return {id:id, qty:isNaN(qty)?1:qty};
  }
  function extractHandle(url){
    try{
      var path=(url||'').split('?')[0], parts=path.split('/').filter(Boolean), i=parts.indexOf('products');
      if(i>=0 && parts[i+1]) return parts[i+1];
      return parts[parts.length-1]||'';
    }catch(e){ return ''; }
  }
  function getTagsByHandle(h){
    if(!h) return Promise.resolve([]);
    return fetchJSON('/products/'+h+'.js').then(function(p){ return (p&&p.tags)?p.tags:[]; }).catch(function(){ return []; });
  }
  var CN_CART_HAS_ENCO = false;
  function deriveCartTags(cart){
    var items=cart.items||[];
    return Promise.all(items.map(function(it){
      var handle = it.handle || extractHandle(it.url||'');
      return getTagsByHandle(handle).then(function(tags){ return {title:it.title, quantity:it.quantity, tags:tags, handle:handle}; });
    })).then(function(arr){
      var hasD=false, hasE=false;
      arr.forEach(function(it){
        var t=(it.tags||[]).map(function(s){ return (s||'').toLowerCase().trim(); });
        if(t.includes('disponivel')||t.includes('disponível')) hasD=true;
        if(t.includes('encomendar')||t.includes('pré-venda')||t.includes('pre-venda')||t.includes('preorder')) hasE=true;
      });
      CN_CART_HAS_ENCO = hasE; return {items:arr, isMixed:(hasD && hasE)};
    });
  }

  // ========== WhatsApp modal ==========
  function suppressCartDrawer(){
    var sels = ['#CartDrawer','.cart-drawer','.drawer--cart','.ajaxcart','.ajaxcart__wrapper','.js-drawer-open-cart','.header-cart','[data-cart-drawer]'];
    sels.forEach(function(sel){
      var el = document.querySelector(sel);
      if(el){
        try{
          el.style.display='none';
          el.classList.remove('open','is-open','active','shown','show');
          el.setAttribute('aria-hidden','true');
        }catch(e){}
      }
    });
  }
  function supressPreorder(){
    ['#preorder-modal','[data-preorder-modal]','#preorderModal','.preorder-modal'].forEach(function(sel){
      var el=q(sel); if(el){ el.style.display='none'; el.classList.remove('open','is-active','active','show'); el.setAttribute('aria-hidden','true'); }
    });
  }
  // Global handler to guarantee single hard refresh from the "Continuar comprando" button
  window.__CNW_CONTINUE_LOCK = false;
  window.cnw_continue_shopping = function(ev){
    try{ if(ev){ ev.preventDefault(); ev.stopImmediatePropagation(); ev.stopPropagation(); } }catch(e){}
    if(window.__CNW_CONTINUE_LOCK) return;
    window.__CNW_CONTINUE_LOCK = true;
    try{
      var ov=document.querySelector('#cn-whatsapp-mixed-overlay');
      if(ov){ ov.classList.remove('cnw-open'); document.body.classList.remove('cnw-modal-open'); }
    }catch(e){}
    // Reset intent flags
    try{ sessionStorage.removeItem('cn_add_disponivel_intent_v1'); }catch(e){}
    try{ sessionStorage.removeItem('cn_encomendar_intent_v6'); }catch(e){}
    try{ window.__CN_FORCE_WHATS_AFTER_ADD=false; }catch(e){}
    // Force a single hard reload
    try{ cnwHardReloadOnce(); }catch(e){ try{ location.reload(); }catch(_){ } }
  };
  // Delegated listener (resilient to DOM rerenders)
  document.addEventListener('click', function(e){
    var el=e.target;
    for(var i=0;i<3 && el;i++, el=el.parentElement){
      if(el && (el.id==='cnw-continue' || el.hasAttribute && el.hasAttribute('data-cnw-continue'))){
        return window.cnw_continue_shopping(e);
      }
    }
  }, true);

  function openWhats(items){ window.__CN_BLOCK_CART_ADD = true;
    var ov=q('#cn-whatsapp-mixed-overlay'); if(!ov) return;
    var box=q('#cnw-items');
    if(box){
      var ul=document.createElement('ul');
      (items||[]).forEach(function(it){ var li=document.createElement('li'); li.textContent=(it.title||'Produto')+' x'+(it.quantity||1); ul.appendChild(li); });
      box.innerHTML=''; box.appendChild(ul);
    }
    var wa=q('#cnw-whatsapp');
    if(wa){
      var lines=(items||[]).map(function(it){return '• '+(it.title||'Produto')+' x'+(it.quantity||1);}).join('%0A');
      wa.href='https://wa.me/351913767399?text='+'Ol%C3%A1!%20Adicionei%20estes%20produtos%20ao%20carrinho:%0A'+lines+'%0AH%C3%A1%20itens%20com%20prazos%20diferentes%20no%20carrinho.%20Pode%20ajudar-me%20a%20finalizar%20corretamente%3F';
    }
    function close(){ ov.classList.remove('cnw-open'); document.body.classList.remove('cnw-modal-open'); window.__CN_BLOCK_CART_ADD=false; }
    var closeBtn=q('.cnw-close'); if(closeBtn){ closeBtn.addEventListener('click', function(ev){ ev.preventDefault(); ev.stopPropagation(); close(); }, {once:true, capture:true}); }
    var cont=q('#cnw-continue');
    ov.addEventListener('click', function(e){ if(e.target===ov) close(); }, {capture:true});
    supressPreorder();
    ov.classList.add('cnw-open'); document.body.classList.add('cnw-modal-open');
  }

  // ========== Modal nativo centralizado + "Continuar" sem refresh ==========
  function openPreorder(){
    // Abrir nosso modal controlado
    var ov = q('#cn-preorder-overlay');
    if(!ov){ return false; }
    // Ativa bloqueio de add enquanto o modal estiver aberto
    window.__CN_BLOCK_CART_ADD = true;

    function close(){
      ov.classList.remove('cnw-open');
      document.body.classList.remove('cnw-modal-open');
      window.__CN_BLOCK_CART_ADD = false; // liberar add novamente
    }
    var btnClose = q('.cnp-close', ov);
    if(btnClose){ btnClose.addEventListener('click', function(ev){ ev.preventDefault(); ev.stopPropagation(); close(); }, {once:true, capture:true}); }
    var cont = q('#cnp-continue', ov);
    if(cont){ cont.addEventListener('click', function(ev){ ev.preventDefault(); ev.stopPropagation(); close(); }, {once:true, capture:true}); }
    ov.addEventListener('click', function(e){ if(e.target===ov){ close(); } }, {capture:true});

    ov.classList.add('cnw-open'); document.body.classList.add('cnw-modal-open');
    return true;
  }

  // ========== Pós-refresh ==========
  var __processing = false;
  function afterRefresh(){
    if(__processing) return;
    var it=readIntent();
    if(!it) return;
    if(now()-it.ts>INTENT_TTL){ clearIntent(); return; }
    __processing = true;

    // Passo A: se ainda não adicionou, adiciona 1x
    if(it.step!=='added'){
      it.step='adding'; saveIntent(it);
      fetch('/cart/add.js', { method:'POST', headers:{'Content-Type':'application/json','Accept':'application/json'}, body: JSON.stringify({ id: it.id, quantity: it.qty||1 }) })
        .catch(function(){})
        .finally(function(){ it.step='added'; saveIntent(it); try{ sessionStorage.setItem('cn_last_preorder', JSON.stringify({id: it.id, qty: it.qty||1, ts: Date.now()})); }catch(e){} decide(); });
      return;
    }
    decide();

    function decide(){
      getCartJSON().then(deriveCartTags).then(function(res){
        if(res.isMixed || window.__CN_FORCE_WHATS_AFTER_ADD){ suppressCartDrawer(); openWhats(res.items); } else { openPreorder(); }
      }).finally(function(){ clearIntent(); __processing=false; });
    }
  }


  // Interceptar "Adicionar ao carrinho" quando já existe ENCOMENDAR no carrinho (PDP)
  function interceptAvailableAdd(){
    var addSelectors = [
      'button[name="add"]',
      '.product-form button[type="submit"]',
      'button.add-to-cart',
      'button[data-add-to-cart]',
      '#AddToCart,#add-to-cart'
    ];

    // Click: se carrinho já tem encomendar, bloqueia e faz add manual + WhatsApp
    document.addEventListener('click', function(ev){
      var el = ev.target, matched = null;
      for(var i=0;i<4 && el;i++, el=el.parentElement){
        for(var s of addSelectors){
          if(el.matches && el.matches(s)){ matched = el; break; }
        }
        if(matched) break;
      }
      if(!matched) return;

      var text = (matched.textContent||'').trim().toLowerCase();
      // ignorar botões de ENCOMENDAR
      if(text.includes('encomendar') || matched.matches('#preorder-button, #encomendar-agora, .button-encomendar, button[data-encomendar], button[name=\"encomendar\"], button.cn-preorder')){
        return;
      }
      if(!CN_CART_HAS_ENCO) return;

      ev.preventDefault(); ev.stopImmediatePropagation(); ev.stopPropagation();
      // desativa para evitar duplo clique
      if(matched.disabled !== undefined){ matched.disabled = true; matched.setAttribute('aria-busy','true'); }
      // bloquear drawer temporariamente
      window.__CN_FORCE_WHATS_AFTER_ADD = true;
      try{ suppressCartDrawer(); }catch(e){}

      var vk = getVariantQty();
      if(!vk.id){ window.__CN_FORCE_WHATS_AFTER_ADD=false; return; }

      fetch('/cart/add.js', {
        method:'POST',
        headers:{'Content-Type':'application/json','Accept':'application/json'},
        body: JSON.stringify({ id: vk.id, quantity: vk.qty||1 })
      })
      .then(function(){ return getCartJSON(); })
      .then(function(cart){ return deriveCartTags(cart); })
      .then(function(res){
        if(res.isMixed || CN_CART_HAS_ENCO){
          suppressCartDrawer();
          openWhats(res.items);
        }
      })
      .finally(function(){
        window.__CN_FORCE_WHATS_AFTER_ADD = false;
        if(matched.disabled !== undefined){ matched.disabled = false; matched.removeAttribute('aria-busy'); }
      });
    }, true);

    // Submit: redundância para temas que submetem o form em vez do click
    document.addEventListener('submit', function(ev){
      if(!CN_CART_HAS_ENCO) return;
      var form = ev.target;
      var action = (form.getAttribute('action')||'').toLowerCase();
      if(action.indexOf('/cart/add') === -1 && !form.querySelector('input[name=\"id\"]')) return;

      // tenta identificar se o botão é de encomendar; se não conseguir, seguimos como disponível
      var btn = form.querySelector('button[type=\"submit\"], button[name=\"add\"], .add-to-cart');
      var isEncoBtn = btn && ((btn.textContent||'').trim().toLowerCase().includes('encomendar') || btn.matches('#preorder-button, #encomendar-agora, .button-encomendar, button[data-encomendar], button[name=\"encomendar\"], button.cn-preorder'));
      if(isEncoBtn) return;

      ev.preventDefault(); ev.stopImmediatePropagation();

      window.__CN_FORCE_WHATS_AFTER_ADD = true;
      try{ suppressCartDrawer(); }catch(e){}

      var idEl = form.querySelector('input[name=\"id\"], select[name=\"id\"]');
      var qtyEl = form.querySelector('[name=\"quantity\"]');
      var id = idEl ? (idEl.value || idEl.getAttribute('value')) : null;
      var qty = qtyEl ? parseInt(qtyEl.value || qtyEl.getAttribute('value') || '1', 10) : 1;
      if(!id){ window.__CN_FORCE_WHATS_AFTER_ADD=false; return; }

      fetch('/cart/add.js', {
        method:'POST',
        headers:{'Content-Type':'application/json','Accept':'application/json'},
        body: JSON.stringify({ id: id, quantity: isNaN(qty)?1:qty })
      })
      .then(function(){ return getCartJSON(); })
      .then(function(cart){ return deriveCartTags(cart); })
      .then(function(res){
        if(res.isMixed || CN_CART_HAS_ENCO){
          suppressCartDrawer();
          openWhats(res.items);
        }
      })
      .finally(function(){ window.__CN_FORCE_WHATS_AFTER_ADD = false; });
    }, true);
  }

  // ========== Clique em ENCOMENDAR (apenas UMA navegação) ==========
  function enhance(){
    var sels=['#preorder-button','#encomendar-agora','.button-encomendar','button[data-encomendar]','button[name="encomendar"]','button.cn-preorder'];
    document.addEventListener('pointerdown', function(e){
      var el=e.target;
      var sels=['#preorder-button','#encomendar-agora','.button-encomendar','button[data-encomendar]','button[name="encomendar"]','button.cn-preorder'];
      for(var i=0;i<4 && el;i++, el=el.parentElement){
        for(var s of sels){
          if(el.matches && el.matches(s)){
            var t=(el.textContent||'').trim().toLowerCase();
            if(t.includes('encomendar')){
              // Pré-sinaliza intenção para bloquear submit nativo em temas que disparam no mousedown
              var vk=(function(){
                var form = document.querySelector('form[action*="/cart/add"]') || document.querySelector('form');
                var idEl = (form && (form.querySelector('input[name="id"]') || form.querySelector('select[name="id"]'))) || document.querySelector('input[name="id"]');
                var qtyEl= (form && form.querySelector('[name="quantity"]')) || document.querySelector('[name="quantity"]');
                var id  = idEl ? (idEl.value || idEl.getAttribute('value')) : null;
                var qty = qtyEl ? parseInt(qtyEl.value || qtyEl.getAttribute('value') || '1',10) : 1;
                return {id:id, qty:isNaN(qty)?1:qty};
              })();
              if(vk.id){
                try{ sessionStorage.setItem('cn_encomendar_intent_v6', JSON.stringify({id:vk.id, qty:vk.qty||1, ts:Date.now(), step:'click'})); }catch(_){}
              }
              return;
            }
          }
        }
      }
    }, true);

    document.addEventListener('click', function(e){
      var el=e.target;
      for(var i=0;i<4 && el; i++, el=el.parentElement){
        for(var s of sels){
          if(el.matches && el.matches(s)){
            var t=(el.textContent||'').trim().toLowerCase();
            if(t.includes('encomendar')){
              e.preventDefault(); e.stopImmediatePropagation(); e.stopPropagation();
              if(el.disabled) return;
              el.disabled=true; el.setAttribute('aria-busy','true');
              var vk=getVariantQty(); if(!vk.id){ return; }
              saveIntent({id:vk.id, qty:vk.qty||1, ts:now(), step:'click'});
              // 1 único refresh: uso replace e adiciono um parâmetro uma única vez
              var url=new URL(window.location.href);
              if(!url.searchParams.get('cnr')){ url.searchParams.set('cnr','1'); }
              window.location.replace(url.toString());
              return;
            }
          }
        }
      }
    }, true);
  }

  // Interceptar submit de forms /cart/add quando houver intenção ativa (evita adição antes do refresh)
  document.addEventListener('submit', function(ev){
    var it = (function(){ try{ return JSON.parse(sessionStorage.getItem('cn_encomendar_intent_v6')||'null'); }catch(e){ return null; } })();
    if(!it) return;
    var form = ev.target;
    var action = (form.getAttribute('action')||'').toLowerCase();
    if(action.indexOf('/cart/add') !== -1 || form.querySelector('input[name="id"]')){
      ev.preventDefault(); ev.stopImmediatePropagation();
      // Garante apenas 1 refresh
      var url = new URL(window.location.href);
      if(!url.searchParams.get('cnr')){ url.searchParams.set('cnr','1'); }
      window.location.replace(url.toString());
    }
  }, true);

  interceptAvailableAdd();

  // ====== Exibir aviso "Produtos Encomendados" apenas quando botão ENCOMENDAR estiver visível ======
  function cnIsVisible(el){
    if(!el) return false;
    var s = window.getComputedStyle ? getComputedStyle(el) : el.style;
    return el.offsetParent !== null && s.display !== 'none' && s.visibility !== 'hidden' && s.opacity !== '0';
  }
  function cnTogglePreorderNotice(){
    try{
      var preorderBtn = document.querySelector('#preorder-button');
      var showNotice = !!(preorderBtn && cnIsVisible(preorderBtn) && !preorderBtn.disabled);

      var previews = Array.prototype.slice.call(document.querySelectorAll('pickup-availability-preview'));
      previews.forEach(function(p){
        var strong = p.querySelector('.pickup-availability-info strong');
        var isPreorderBlock = strong && /produtos\s+encomendados/i.test((strong.textContent||'').trim());
        if(isPreorderBlock){
          p.style.display = showNotice ? '' : 'none';
        }
      });
    }catch(e){}
  }

  // Inicializa e observa mudanças (variação, trocas de DOM, etc.)
  try{
    document.addEventListener('DOMContentLoaded', cnTogglePreorderNotice);
    // Dispara logo no boot também
    cnTogglePreorderNotice();

    var mo = new MutationObserver(function(m){
      // Reavalia em qualquer mudança relevante
      cnTogglePreorderNotice();
    });
    mo.observe(document.body, {subtree:true, childList:true, attributes:true, attributeFilter:['style','class','disabled','hidden']});

    // Reage a mudanças de selects/inputs da PDP
    document.addEventListener('change', function(e){
      if(e.target && e.target.closest && e.target.closest('form[action*="/cart/add"]')){
        cnTogglePreorderNotice();
      }
    }, true);
  }catch(e){}

  enhance();
  /*INIT_CN_CART_FLAG*/
  try{ getCartJSON().then(deriveCartTags).catch(function(){}); }catch(e){}

  if(document.readyState==='complete' || document.readyState==='interactive'){ afterRefresh(); }
  else { document.addEventListener('DOMContentLoaded', afterRefresh); }

})();
  // ====== Finalizar compra (preorder modal): garantir quantidades e ir ao checkout ======
  (function(){
    function goCheckout(ev){
      try{ if(ev){ ev.preventDefault(); ev.stopImmediatePropagation(); ev.stopPropagation(); } }catch(e){}
      var btn = ev && ev.target;
      if(btn && btn.disabled) return;
      if(btn){ try{ btn.disabled = true; btn.setAttribute('aria-busy','true'); }catch(e){} }

      var data = null;
      try{ data = JSON.parse(sessionStorage.getItem('cn_last_preorder')||'null'); }catch(e){ data = null; }
      if(!data){
        try{ data = JSON.parse(sessionStorage.getItem('cn_encomendar_intent_v6')||'null'); }catch(e){ data = null; }
      }
      var vid = data && data.id, qty = data && (data.qty||1);

      function redirect(){
        try{ sessionStorage.removeItem('cn_encomendar_intent_v6'); }catch(e){}
        try{ sessionStorage.removeItem('cn_last_preorder'); }catch(e){}
        var to = (window.routes && window.routes.checkout_url) ? window.routes.checkout_url : '/checkout';
        window.location.href = to;
      }

      if(!vid){ return redirect(); }

      fetch('/cart/update.js', {
        method: 'POST',
        headers: {'Content-Type':'application/json','Accept':'application/json'},
        body: JSON.stringify({ updates: { [vid]: qty } })
      }).catch(function(){ }).finally(redirect);
    }

    document.addEventListener('click', function(e){
      var el = e.target;
      for(var i=0;i<3 && el;i++, el=el.parentElement){
        if(el && el.id === 'cnp-checkout'){
          return goCheckout(e);
        }
      }
    }, true);
  })();
